module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('BackTop', {
    attrs: {
      "height": 150,
      "bottom": 80,
      "right": 80
    }
  }, [_c('div', {
    staticClass: "float-btn back-top"
  }, [_c('chevron-up-icon', {
    staticClass: "icon-chevron-up",
    attrs: {
      "size": "1.5x"
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-help-box"
  }, [_c('a', {
    staticClass: "float-btn report",
    attrs: {
      "href": "https://support.qq.com/products/297963"
    }
  }, [_c('i', {
    staticClass: "icon-shield"
  }), _vm._v(" "), _c('span', [_vm._v("举报")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94aace5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./pc/yiqijian-video/components/BackTop/index.vue
// module id = 53
// module chunks = 1 2 3 4 5